<template>
  <div class="row">
    <el-dialog
      center
      title="Data Import"
      :closeOnClickModal="false"
      :closeOnPressEscape="false"
      :showClose="false"
      :visible.sync="modals.dataimport"
    >
      <div style="width: 100%; word-break: normal">
        <ul style="font-size: 13px">
          <!-- <li>Congratulations, as an Alpha user you get early access!</li>
          <li>Please select "Download XLS" to get the portfolio template.</li>
          <li>
            Once downloaded you can upload your portfolio via the template or
            use the template data on the file to test the product.
          </li>-->
          <li>Let's setup your workspace!</li>
          <li>
            Workspaces are where we create and track a portfolio of investments.
          </li>
          <li>
            You can invite team members, investment groups, co-investor or
            venture partners and easily share deal flow.
          </li>
          <!-- <li>Would you like to upload some companies from the spreadsheet template or add them manually?</li> -->
        </ul>
      </div>
      <div class="import-callout row">
        <div class="col-sm">
          <img src="static/img/uploadXlxs.svg" />
          <a
            class="btn btn-info btn-fill btn-wd"
            :href="`#/${$route.params.account_id}/${$route.params.workspace_id}/portfolio/import`"
            >Upload Excel</a
          >
        </div>
        <div class="col-sm word-break">
          <i class="fa fa-pencil fa-5x" aria-hidden="true"></i>
          <button
            class="btn btn-info btn-fill btn-wd"
            @click="handleCreateCompany"
          >
            Manual Entry
          </button>
          <!-- <span>Coming soon!</span> -->
        </div>
        <!-- <div class="col-sm word-break">
          <i class="fa fa-google fa-5x notactiv" aria-hidden="true"></i>
          <button class="btn btn-default btn-fill disabled">Import Google Sheet</button>
          <span>Coming soon!</span>
        </div> -->
        <div class="col-sm">
          <i class="fa fa-file-excel-o fa-5x" aria-hidden="true"></i>
          <a
            class="btn btn-info btn-fill btn-wd"
            @click="downloadSample"
            :href="`#/${$route.params.account_id}/${$route.params.workspace_id}/portfolio/import`"
            >Download XLS</a
          >
          <a
            class="hidden"
            ref="hiddenDownloadAnchor"
            href="https://www.dropbox.com/s/i0y6cmzot51vzyn/ExampleXLS_0.2.xlsx?dl=1"
            >Download Sample</a
          >
          <span></span>
        </div>
      </div>
    </el-dialog>

    <div class="col-12" style="padding: 0">
      <card
        title
        class="borderless-card portfolio-card"
        style="box-shadow: none"
      >
        <div
          class="row mb-2 mt-2"
          style="justify-content: space-between; margin: auto"
        >
          <div class="team-title d-flex" style="padding-left: 1.3rem">
            <i class="material-icon-font material-icons user-font mr-2"
              >work_outline</i
            >
            <div style="margin-top: auto; margin-bottom: auto">
              <span>Portfolio</span>
              <span style="color: #00000080"
                >({{ portfolioData.length }} companies)</span
              >
            </div>
          </div>
          <div class="d-flex" style="padding-right: 30px">
            <div style="margin-right: 16px">
              <b-dropdown variant="link" class="add-company-dropdown" no-caret>
                <template v-slot:button-content>
                  <i
                    class="fas fa-share-alt user-font mr-2"
                    style="font-size: 14px"
                  ></i>
                  <span class="user-font share-portfolio">Share Portfolio</span>
                </template>
                <b-dropdown-item @click="openSendEmail"
                  >Send Email</b-dropdown-item
                >
                <b-dropdown-item @click="downloadCSV"
                  >Download CSV</b-dropdown-item
                >
              </b-dropdown>
            </div>
            <div class v-if="showAddCompany">
              <b-dropdown
                id="dropdown-1"
                text="Add Company"
                class="add-company-dropdown"
                no-caret
              >
                <template v-slot:button-content>
                  <i class="fa fa-plus" aria-hidden="true"></i> Add Company
                </template>
                <b-dropdown-item @click="handleCreateCompany"
                  >Add Company</b-dropdown-item
                >
                <b-dropdown-item
                  :href="`#/${$route.params.account_id}/${$route.params.workspace_id}/portfolio/import`"
                  >Upload Excel</b-dropdown-item
                >
              </b-dropdown>
            </div>
          </div>
        </div>

        <div style="margin-bottom: 10px">
          <direct-investment
            ref="directInvestRef"
            @download-complete="downloadComplete()"
          ></direct-investment>

          <!-- <b-tabs>
            <b-tab
              title="Direct Investments"
              active-nav-item-class="border-bottom: #5445F3 0% 0% no-repeat padding-box"
              active
            >
            </b-tab>
          </b-tabs>-->
        </div>
        <!-- 
        <div
          slot="footer"
          class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
        ></div>-->
      </card>
    </div>
    <el-dialog
      left
      title="Share Portfolio"
      :closeOnClickModal="false"
      :closeOnPressEscape="false"
      :showClose="true"
      width="500px"
      @close="
        sharingNote = '';
        tags = [];
        refreshForm = false;
      "
      style="margin: 0 auto"
      :visible.sync="modalShow"
      class="team-modal col-lg-12 col-sm-12 col-12 col-md-12"
    >
      <div>
        <div>Email</div>
        <b-form-group :state="state" label-for="tags-validation">
          <b-form-tags
            input-id="tags-validation"
            invalid-tag-text="Invalid email(s)"
            duplicate-tag-text="Duplicate email(s)"
            :input-attrs="{ 'aria-describedby': 'tags-validation-help' }"
            v-model="tags"
            :state="state"
            v-if="refreshForm"
            placeholder="Enter Emails separated by comma"
            tag-variant="primary"
            add-on-change
            tag-pills
            :tag-validator="tagValidator"
            @tag-state="onTagState"
            separator=","
          ></b-form-tags>
          <!-- The following slots are for b-form-group
          <template v-slot:invalid-feedback>You must provide at least 1 email and no more than 6</template>-->
          <!-- <template v-slot:description>
            <div id="tags-validation-help">Must be a valid Email</div>
          </template>-->
        </b-form-group>
        <div>Notes</div>
        <textarea
          placeholder="Note"
          rows="5"
          cols="50"
          class="form-control"
          spellcheck="false"
          v-model="sharingNote"
        ></textarea>
        <div class="edit-company-action-button-row py-3" style="margin: 0px">
          <button
            type="button"
            @click="modalShow = !modalShow"
            class="todo-form-cancel-button btn-outline-secondary"
          >
            Cancel
          </button>
          <button
            type="submit"
            @click.prevent="sendEmail"
            :disabled="emailCheck || submit"
            class="todo-form-submit-button btn btn-primary"
            style="height: 35px"
          >
            Send
            <b-spinner
              v-if="submit"
              style="float: right"
              small
              label="Loading..."
            ></b-spinner>
          </button>
        </div>
      </div>
    </el-dialog>
    <addCompany
      v-model="addCompanyProps"
      v-if="showAddCompanyModal"
    ></addCompany>
  </div>
</template>
<script>
import moment from "moment";
import util from "util";
import { Select, Option, Dialog } from "element-ui";
import Tabulator from "tabulator-tables";
import { Pagination as LPagination } from "src/components/index";
import AddCompany from "../Dialogs/AddCompany";
import {
  stageSelect,
  statusSelect,
  directSelect,
  numberSorter,
} from "./investments";
import DirectInvestment from "./DirectInvestment";
import LimitedPartner from "./LimitedPartner";
import { mapGetters } from "vuex";
import Fuse from "fuse.js";
import _ from "lodash";
import swal from "sweetalert2";
import { vals } from "../../../util";
import DialogConfirmCompany from "../Dialogs/DialogConfirmCompany";
import api from "../../../axios_api";
const stringify = JSON.stringify;

const DATA_STATUS_CONFIRMED = "Confirmed";
const DATA_STATUS_UNCONFIRMED = "Unconfirmed";
const DATA_STATUS_UPDATING = "Retrieving";

export default {
  components: {
    LPagination,
    AddCompany,
    [Select.name]: Select,
    [Option.name]: Option,
    [Dialog.name]: Dialog,
    [DialogConfirmCompany.name]: DialogConfirmCompany,
    DirectInvestment,
    LimitedPartner,
  },
  computed: {
    ...mapGetters("portfolio", ["portfolioData", "hasData", "dataLoaded"]),
    ...mapGetters("user", ["currency", "firstName", "lastName"]),
    ...mapGetters("user", ["user"]),
    ...mapGetters("role", ["getCurrentWorkspaceRolePermissions"]),
    emailCheck() {
      if (this.tags.length > 0 && this.invalidTags.length == 0) return false;
      else return true;
    },
    state() {
      return this.dirty ? this.tags.length > 0 && this.tags.length < 10 : null;
    },
    showAddCompany() {
      let rolePermissions = this.getCurrentWorkspaceRolePermissions;
      let index = rolePermissions.findIndex((item) => {
        if (item == "ADD COMPANY") {
          return item;
        }
      });
      return index >= 0 ? true : false;
    },
  },
  data() {
    return {
      modals: {
        custom: false,
        dataimport: false,
      },
      tabulator: null,
      tags: [],
      validTags: [],
      invalidTags: [],
      duplicateTags: [],
      modalShow: false,
      dirty: false,
      isEditing: false,
      tempData: null,
      submit: false,
      refreshForm: true,
      sharingNote: "",
      addCompanyProps: {},
      showAddCompanyModal: false,
    };
  },
  watch: {
    tableData: {
      handler: function (newData) {
        if (!this.isEditing && this.tabulator) {
          if (!this.tabulator.rowManager.displayRowsCount) {
            this.tabulator.replaceData(newData);
          } else {
            this.tabulator.updateData(newData);
          }
        } else {
          this.tempData = newData;
        }
      },
    },
    tags(newVal, oldVal) {
      // Set the dirty flag on first change to the tags array
      this.dirty = true;
    },
  },
  methods: {
    checkDataLoaded() {
      let self = this;
      
      if (self.dataLoaded) {
        let data = this.$store.getters["portfolio/portfolioData"];
        if (data.length <= 0) {
          if (!self.$route.query.new) {
            self.openModal("dataimport");
          }
        } else {
          if (self.$route.query.f) {
            self.tabulator.setSort("data_status");
          }
        }
      } else {
        setTimeout(() => {
          self.checkDataLoaded();
        },1000);
      }
    },
    handleCreateCompany() {
      this.modals.dataimport = false;
      this.addCompanyProps = {
        isShow: true,
        data: {},
      };
      this.showAddCompanyModal = true;
    },
    onTagState(valid, invalid, duplicate) {
      this.validTags = valid;
      this.invalidTags = invalid;
      this.duplicateTags = duplicate;
    },
    openModal(name) {
      this.modals[name] = true;
    },
    downloadComplete() {
      this.submit = false;
      this.$toaster.success("Email will be sent shortly.");
      this.modalShow = false;
    },
    tagValidator(tag) {
      let value = tag.length > 5 && tag.includes("@") && tag.includes(".");
      return value;
    },
    closeModal(name) {
      this.modals[name] = false;
    },
    computeGainLoss(data) {
      return data.value - data.cost;
    },
    computeMultiple(data) {
      return (data.value / data.cost).toFixed(2);
    },
    handleDelete(index, row) {
      let indexToDelete = this.tableData.findIndex(
        (tableRow) => tableRow.id === row.id
      );
      if (indexToDelete >= 0) {
        this.tableData.splice(indexToDelete, 1);
      }
    },
    downloadSample(event) {
      this.$refs.hiddenDownloadAnchor.click();
    },
    downloadCSV() {
      this.$refs.directInvestRef.isCSV = true;
      this.$refs.directInvestRef.download();
      this.$toaster.success("Downloaded Successfully");
    },
    openSendEmail() {
      this.tags = [];
      this.submit = false;
      this.$refs.directInvestRef.emails = [];
      this.modalShow = true;
      this.refreshForm = true;
    },
    sendEmail() {
      this.submit = true;
      this.$refs.directInvestRef.emails = this.tags;
      this.$refs.directInvestRef.sharingNote = this.sharingNote;
      this.$refs.directInvestRef.isCSV = false;
      this.$refs.directInvestRef.download();
    },
    checkDataStatus() {
      let check = false;
      for (let i = 0; i < this.portfolioData.length; i++) {
        if (this.portfolioData[i]["data_status"] == DATA_STATUS_UPDATING) {
          check = true;
          break;
        }
      }
      if (check && !this.isEditing) {
        this.$store.commit("infobox/infoBoxVisibility", {
          show: true,
          displayText: `Sit tight. We're now populating the data from your companies.
            When enough data has been populated, click the company verify 
            it, after which you can view and edit that company.`,
        });
        this.$store.dispatch("portfolio/_apiFetchPortfolio");
        // this.$store.dispatch("people/apiFetchPeople");
      }
    },
  },
  created() {
    //this.$store.getters["todo/portfolioTodos"];
    // this.$store.getters["todo/componentTodos"](
    //   "portfolio",
    //   this.$route.params.workspace_id
    // );
  },
  mounted() {
    window.moment = moment;
    let self = this;
    self.$store.commit("todo/setCurrentComponent", "portfolio");
    // let data = this.$store.getters["portfolio/hasData"];
    const titleEl = document.querySelector("head title");
    titleEl.textContent = `Fiifi | Portfolio`;

    self.checkDataLoaded();
  },

  beforeDestroy() {
    this.$store.commit("infobox/infoBoxVisibility", {
      show: false,
      displayText: ``,
    });

    if (this.invervalHandle) {
      clearInterval(this.invervalHandle);
    }
  },
};
</script>
<style lang="scss">
.portfolio-card .nav-tabs {
  border-bottom: 1px solid #dee2e6;
  padding-left: 10px;
  width: 100%;
}
.share-btn .text-decoration-none {
  padding: 0px;
  margin: 0px;
}
.has-search .form-control {
  padding-left: 2.375rem;
}

.has-search .form-control-feedback {
  position: absolute;
  z-index: 2;
  display: block;
  width: 2.375rem;
  height: 2.375rem;
  line-height: 2.375rem;
  text-align: center;
  pointer-events: none;
  color: #aaa;
  margin-top: 4px;
}
.img-div {
  position: relative;
}
.img-div img {
  width: 100%;
  height: auto;
}
.tabulator-responsive-collapse {
  margin-left: 276px;
  padding: 0px;
  padding-top: 5px;
}
.b-form-tags-button {
  display: none !important;
}

.b-form-tag {
  background: #ededed 0% 0% no-repeat padding-box;
  border-radius: 12px;
  color: black;
  height: 24px;
  font-size: 12px;
}
.team-modal .invalid-feedback {
  margin-top: 0;
  font-size: 10;
}
/*@media only screen and (max-width: 1400px) {
  #theMainTableBoxInvestments {
    overflow-x: scroll;
  }

  #theMainTableFixerInvestments {
    width: 1300px;
  }
}*/

/* #theMainTableBoxInvestments
  > #theMainTableFixerInvestments
  > .tabulator
  > .tabulator-tableHolder
  > .tabulator-table
  > .tabulator-row
  > .tabulator-cell:first-child {
  color: #0097a7;
  text-decoration: underline;
} */
.tabulator .tabulator-header .tabulator-col .tabulator-col-content {
  // padding: 20px;
  height: 50px;
  padding-top: 10px;
}
.downloadCsv {
  float: right;
  margin-top: 20px;
}
.tabulator
  .tabulator-header
  .tabulator-col
  .tabulator-col-content
  .tabulator-col-title {
  text-overflow: ellipsis;
  white-space: initial;
}
.word-break {
  word-break: normal;
}

.word-break {
  word-break: normal;
}

.link {
  height: 20px;
}

.hidden {
  display: none;
}
.tabulator {
  .normal-data-status {
    font-weight: bold;
    font-size: 12px;
    i {
      margin-right: 6px;
    }
  }
  .warn-data-status {
    color: #fea012;
    font-weight: bold;
    font-size: 12px;
    i {
      background-color: #fea012;
      color: #fff;
      padding: 2px;
      border-radius: 100%;
      font-weight: bolder;
      box-sizing: border-box;
      display: inline-block;
      width: 17px;
      height: 17px;
      display: inline-block;
      text-align: center;
    }
  }
  .success-data-status {
    color: #79c566;
    font-weight: bold;
    font-size: 12px;
    i {
      background-color: #79c566;
      color: #fff;
      padding: 2px;
      border-radius: 100%;
      font-weight: bolder;
      box-sizing: border-box;
      display: inline-block;
    }
  }

  .gray-row {
    .tabulator-cell[tabulator-field="rating"] {
      svg {
        opacity: 0.1;
      }
    }
    .tabulator-cell:not(:first-child) {
      // background-color: #FFF;
      color: #bfbfbf;
    }
  }

  .tabulator-row:hover {
    background-color: #c6c9cf;
  }
  .tabulator-row {
    transition: all 0.1s ease 0s;
  }
  .tabulator-row.gray-row.tabulator-selectable:hover {
    background-color: inherit;
    cursor: default;
  }
}
</style>
